import { render, staticRenderFns } from "./btn-form.vue?vue&type=template&id=786c25ae&scoped=true"
import script from "./btn-form.vue?vue&type=script&lang=ts"
export * from "./btn-form.vue?vue&type=script&lang=ts"
import style0 from "./btn-form.vue?vue&type=style&index=0&id=786c25ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786c25ae",
  null
  
)

export default component.exports